<script setup lang="ts">
import { MtdButton, MtdTypography } from '@paygine/mtd-uikit'

import { useModel } from '@/pages/tollroads_enroll_page/model'
import { createRedirectLink } from '@/shared/lib/utils'
import { VPayMethod } from '@/shared/ui'

const { createSbpSubscription, isLoading } = useModel()

async function subscribe() {
    const redirectUrl = await createSbpSubscription()

    if (redirectUrl) {
        window.location.href = createRedirectLink(redirectUrl)
    }
}
</script>

<template>
    <div>
        <MtdTypography
            variant="header-2"
            class="default-layout__title"
            tag="h1"
            >Подтвердите способ оплаты
        </MtdTypography>

        <MtdTypography
            tag="p"
            variant="body-2"
            class="default-layout__subtitle"
            >Для подключения безакцептного списания при пользовании платными дорогами
        </MtdTypography>

        <VPayMethod
            class="mt-32"
            :can-edit="false"
            :bank="{
                bank_name: 'Совкомбанк',
                id: 0,
            }"
        />

        <MtdButton
            type="button"
            variant="main"
            class="mt-32"
            :is-loading="isLoading"
            @click="subscribe"
            >Подтвердить и оформить подписку</MtdButton
        >
    </div>
</template>
